import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import ScoresPage from './scoresPage';


const Golf = (props) => {

    const { allSports } = props;
    const [leagueList, setLeagueList] = useState([]);


    useEffect(() => {
        const groups = allSports.filter(sport => sport.group === "Golf" && sport.active)
        setLeagueList(groups)
    }, [allSports])


    return (
        <div className='sport-page'>
                <Router>
            <div className='leagues-list'>
                {leagueList.map(league =>
                    <Link to={`/Golf/${league.key}`} key={league.key} >{league.title}</Link>
                )}
            </div>
                <Route path='/Golf/:leagueKey' >
                    <ScoresPage />
                </Route>
            </Router>
        </div>

    )

}


export default Golf;